import { createAction } from '@ngrx/store';

export class AppActions {
	public static initialize = createAction('[App] Initialize');
}
